import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { EVENT } from './constants';
import { isFunction } from '../../../common/utils/core';

export default class EventListener extends PureComponent {
  static propTypes = {
    toggleEnquireModal: PropTypes.func.isRequired,
  };

  handlers = {
    [EVENT.enquire]: () => this.props.toggleEnquireModal(true),
  };

  componentDidMount() {
    document.addEventListener('click', this.handleEvent);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleEvent);
  }

  handleEvent = event => {
    const name = event.target.dataset.event;
    if (!name) return;

    const method = this.handlers[name];
    if (!isFunction(method)) return;

    event.preventDefault();
    this.handlers[name]();
  };

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/components/EventListener/EventListener.js